import { getAuthAxios } from "@artprov/design-system";
import { errorService } from "../../../common/utils/functions/error.service.js";

export const getEstadisticas = async (filtros = {}, signal = null) => {
    try {
        const { banco, fechaDesde, fechaHasta, estado, fechaEstadoDesde, fechaEstadoHasta, grupo, search } = filtros;

        const params = new URLSearchParams();

        if (banco) params.append('banco', banco);
        if (fechaDesde) params.append('fechaDesde', fechaDesde);
        if (fechaHasta) params.append('fechaHasta', fechaHasta);
        if (estado) params.append('estado', estado);
        if (fechaEstadoDesde) params.append('fechaEstadoDesde', fechaEstadoDesde);
        if (fechaEstadoHasta) params.append('fechaEstadoHasta', fechaEstadoHasta);
        if (grupo) params.append('grupo', grupo);
        if (search) params.append('search', search);

        const url = params.toString()
            ? `/matching-bancario/estadisticas?${params}`
            : `/matching-bancario/estadisticas`;

        const response = await getAuthAxios("default").get(
            url,
            signal ? { signal } : undefined
        );

        return response.data;
    } catch (error) {
        errorService.handleError(error, {
            userMessage: "No pudimos obtener las estadísticas.",
            origen: "getEstadisticas"
        });
        throw error;
    }
};

export const parseEstadisticas = (data) => {
    if (!data) return null;

    return {
        match100: data.match100 || 0,
        matchMenor100: data.matchMenor100 || 0,
        noMatch: data.noMatch || 0,
        confirmados: data.confirmados || 0,
        aProcesar: data.aProcesar || 0,
        conError: data.conError || 0,
        descartados: data.descartados || 0,
    };
};
